var _image;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "41px",
    viewBox: "0 0 40 41",
    enableBackground: "new 0 0 40 41",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 40,
    height: 41,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAApCAMAAABwfJv6AAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABMlBMVEX///////3+///29P/h 1P/TvP/GqP/Fp//Fqf/EqP3GqP7Fqf7Nsv/j1P///v/i0/7Anv+UXf+MUv6MUv+NU/+LUf65k//w 6P/+/v739P+hcv64lP/EqP+4kv+icf/Anv3+/v/x6f+daP+3kf+aaP/v6v+baf/p3v+qfP/49f/u 6f+icf6qff7Tvf6aaP2TXf3Ls/+cZ//Tv/7byP/cyf+LU/+3k/+ic//i0v/p3v749f79/v/Fp/32 8/7Hqf+VXf/39P3t6v+off/39f/j0/+uh/7Tvv+NUf+jcv+/nf7w6P2SXv+9nf6ofv79//6wif/o 3f/Uvv+hcv+OUv/Svf6baf62kv+/nP/x6f6Zaf22kv7Ls/3ax/6TXP/v6v6cZ/3u6f3//f6viP2L Uf2UXP28nP8qHi5iAAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB+YF CBMSBRdjbNUAAAKYSURBVDjLfVULX9MwEL9k2hbGCs1trMWhbGZjHQ43ccwHMq3oAHGK4gvfr+// Fbw27ZpC6/1+Tdrkf5f/vVKAUBjw0pWrhmlYC1Ysi6ZVNpcqahfsCMYZLK84AhHDZy5VrAl0VusR yI0Gb4Uga9fMsmkuJhYbDathrF8nhRveBihpthAtz4XLwqF+syZkO8ZJ0dmMmMBGBsaSbdmMtLrY 8bWNS9Lbwlvh3K9ut106pECYy3u3cUBvQ7wTkiF7bhyFS7KDDsBdHCraiaTgdK2Ly7AemYUkVszW vJ/rDEa7MMZ7dpZhDt37KAHxgXLXBcZS1x/qUXB9Iol4IW65gkIHxmivv2fteDpLHqIEuhlTj/Yn KCXiyuM0XoxQIETsrzr6iXQaHrjtJUf6mltkUTua4HycVkAQqrIcYGi2j4R7Gr7bB1iBAoskwTMa xvI5neoGASsA2uUeLq560MJp0KN0OIUWDyU6VHsd6ogjojFNQ6sDac0/xNYxgBw5exTHwYt8ixRO 1z/pkcKJVQoXXnZpmBU4Y796DVxFuYmnbB7JCBjVQlRiNLyRx4pYuxVAvKZy/Tab63pLnhG/0v7k XVPLdpTrJJ9xRt4LsU25/lDS9WuKY7alP54ZVt/Ta4+FqBFmcFxT43Nf7CqCg37CxbYVEly+Ycda yqpPFj/hZtJE2QrXvyo4hvPqUk6zpj0bEfmMu3CAAftPs/BQicvpFyCSO5GBYvTsDDs0DcTXdh4v LQkdPA3nrjhs5nW9HRP1hhioXHRq8psLBTLblCNZV+/HQ4HrTXvGcw4vlVF8//Ez/vKP6Kre+mWE 93Zyhy8YRsPaXcMpHnmJOl2jvfMJ/QWq2d/Cb1r487dy8ZjlQdnSxGiYlnVamRfHPxkYQlC7kypr AAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIyLTA1LTA4VDE2OjE4OjA1KzAzOjAwwGucUQAAACV0RVh0 ZGF0ZTptb2RpZnkAMjAyMi0wNS0wOFQxNjoxODowNSswMzowMLE2JO0AAAAASUVORK5CYII="
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.96078a50f25c5760ae79c8837e3a2a85.svg";
export { ForwardRef as ReactComponent };